import React from 'react';
import PropTypes from 'prop-types';
import Polyline from './layers/Polyline';
import Marker from './markers/Marker';
import { latLngFromObj } from '../../lib/map_helpers';
import { formattedTime } from '../../lib/view_helpers';

const breadcrumbIcon = { html: '', size: [8, 8], anchor: 'center', className: 'breadcrumb-marker' };

export default class VehicleTrail extends React.Component {
  renderBreadcrumbs() {
    return this.props.positions.map((position) => (
      <Marker key={position.id} position={latLngFromObj(position)} type="vehicleBreadcrumb" icon={breadcrumbIcon}>
        {`${formattedTime(position.recorded_at)} UTC`}
      </Marker>
    ));
  }

  render() {
    return (
      <>
        <Polyline
          positions={this.props.positions.map((pos) => latLngFromObj(pos))}
          color="#888"
          opacity={0.5}
          weight={2}
          withDirectionArrows
        />
        {this.renderBreadcrumbs()}
      </>
    );
  }
}

VehicleTrail.propTypes = {
  positions: PropTypes.arrayOf(
    PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number,
      recorded_at: PropTypes.string
    })
  ).isRequired
};
